module.exports = __webpack_public_path__ + "img/back.2431a2fe.png";